<div
  class="flex flex-col gap-(--appointment-card-gap) px- rounded-(--appointment-card-border-radius) bg-(--appointment-card-background) overflow-hidden"
  [class]="config().border ? 'border  border-(--appointment-card-border-color)' : ''"
>
  <div
    class="flex flex-col gap-(--appointment-card-gap) px-(--appointment-card-padding-x) py-(--appointment-card-padding-y)"
  >
    @if (config().chipText) {
      <div class="w-fit">
        <app-dynamic
          componentName="Chip"
          [props]="{ config: { text: config().chipText!, variant: 'primary' } }"
        />
      </div>
    }

    <div class="flex items-center gap-4 w-full">
      @if (config().avatarUrl || config().avatarInitials) {
        <app-dynamic
          componentName="Avatar"
          [props]="{ config: { size: 'lg', imageUrl: config().avatarUrl, initials: config().avatarInitials } }"
        />
      }

      <div class="flex flex-col flex-1 gap-2 min-w-0">
        <div class="flex items-center gap-2">
          <div class="flex flex-col max-w-[209px]">
            <app-dynamic
              componentName="DynamicText"
              [props]="{
                config: {
                  text: config().title1,
                  size: '2xl',
                  fontWeight: 'semibold',
                  whiteSpace: config().whiteSpace,
                  color: 'var(--appointment-card-title-color)',
                  tag: 'h3',
                },
              }"
            />
            @if (config().title2) {
              <app-dynamic
                componentName="DynamicText"
                [props]="{
                  config: {
                    text: config().title2,
                    size: '2xl',
                    fontWeight: 'semibold',
                    whiteSpace: config().whiteSpace,
                    color: 'var(--appointment-card-title-color)',
                    tag: 'h3',
                  },
                }"
              />
            }
          </div>
          @if (config().infoAction) {
            <app-dynamic
              componentName="Button"
              [props]="{
                config: {
                  severity: 'info',
                  text: true,
                  iconOnly: true,
                  leftIcon: 'info',
                  size: 'large',
                  action: config().infoAction,
                },
              }"
              (action)="onButtonClick($event)"
            />
          }
        </div>
        @if (config().subtext) {
          <app-dynamic
            componentName="DynamicText"
            [props]="{
              config: {
                text: config().subtext,
                size: 'xs',
                fontWeight: 'bold',
                whiteSpace: config().whiteSpace,
                color: 'var(--appointment-card-subtext-color)',
              },
            }"
          />
        }
      </div>
    </div>

    @if (config().secondaryButtons?.length) {
      <div class="flex flex-col gap-3 w-full">
        @for (item of config().secondaryButtons; track item.title) {
          <app-dynamic
            componentName="RowButton"
            [props]="{
              config: {
                variant: item.variant || 'secondary',
                leadingIcon: item.icon,
                title: item.title,
                supportingText: item.supportingText,
                showChevron: item.showChevron,
                action: item.action,
              },
            }"
            (action)="onButtonClick($event)"
          />
        }
      </div>
    }
  </div>

  @if (config().tertiaryButton; as tertiaryButton) {
    <button
      type="button"
      [attr.aria-label]="tertiaryButton.title"
      class="px-(--appointment-card-padding-x) py-(--appointment-card-padding-y) border-t border-(--appointment-card-border-color) transition-colors cursor-pointer hover:text-(--appointment-card-hover-color)"
      (click)="onButtonClick(tertiaryButton.action)"
    >
      <app-dynamic
        componentName="DynamicText"
        [props]="{
          config: {
            text: tertiaryButton.title,
            size: 'base',
            fontWeight: 'bold',
            whiteSpace: config().whiteSpace,
            color: 'inherit',
          },
        }"
      />
    </button>
  }
</div>
